import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';

// material-ui
import { Grid, Box, Divider, Typography } from '@mui/material';

// project imports
import MainCard from 'ui-component/cards/MainCard';
import SkeletonPopularCard from 'ui-component/cards/Skeleton/PopularCard';

// icons
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import FacebookIcon from '@mui/icons-material/Facebook';
import MessageIcon from '@mui/icons-material/Message';

// ==============================|| DASHBOARD DEFAULT - Social CARD ||============================== //

const Social = ({ isLoading }) => {
    return (
        <>
            {isLoading ? (
                <SkeletonPopularCard />
            ) : (
                <MainCard content={false} sx={{ mb: 2, p: 2 }}>
                    <Typography variant="h3" color="inherit" align="center" sx={{ my: 2 }}>
                        وانیک در شبکه‌های اجتماعی
                    </Typography>
                    <Grid container rowSpacing={1} alignItems="start" justifyContent="start" sx={{ p: 2 }}>
                        <Grid item color="gray">
                            <Typography variant="h4" color="inherit" sx={{ my: 1 }}>
                                ایتا:
                            </Typography>
                            <Typography variant="subtitle1" color="inherit" sx={{ mt: 1, display: 'flex' }}>
                                <MessageIcon />
                                <span dir="ltr"> +98 930 830 7410 </span>
                            </Typography>
                            <Divider sx={{ my: 2 }} />
                            <Typography variant="h4" color="inherit" sx={{ my: 1 }}>
                                بله:
                            </Typography>
                            <Typography variant="subtitle1" color="inherit" sx={{ mt: '1', display: 'flex' }}>
                                <CheckCircleIcon />
                                <span dir="ltr"> +98 930 830 7410 </span>
                            </Typography>
                            <Divider sx={{ my: 2 }} />
                            <Typography variant="h4" color="inherit" sx={{ my: 1 }}>
                                فیس بوک:
                            </Typography>
                            <Typography variant="subtitle1" color="inherit" sx={{ mt: '1', display: 'flex' }}>
                                <FacebookIcon />
                                 facebook.com/vaneek
                            </Typography>
                            <br />
                        </Grid>
                    </Grid>
                </MainCard>
            )}
        </>
    );
};

Social.propTypes = {
    isLoading: PropTypes.bool
};

export default Social;
